import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Button from '../ui/Button';
import Container from '../ui/Container';

const Hero: React.FC = () => {
  return (
    <div className="pt-32 pb-20 md:pt-40 md:pb-32 bg-gradient-to-b from-background via-neutral-900/50 to-background">
      <Container>
        <div className="max-w-4xl mx-auto text-center px-4">
          <span className="text-primary text-sm font-semibold uppercase tracking-wider mb-4 block">
            Building AI Strategies, Together!
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            Turning AI Ideas into{' '}
            <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Market-Ready Products
            </span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-neutral-300 mb-12 max-w-3xl mx-auto">
            We collaborate with innovators to bring AI concepts to life through tailored strategies, expert insights, and lean, hands-on execution.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href="https://calendly.com/productleap/30min" target="_blank" rel="noopener noreferrer">
              <Button size="lg" className="group w-full sm:w-auto">
                Book a Strategy Call
                <ArrowRight size={18} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <Link to="/services">
              <Button variant="secondary" size="lg" className="w-full sm:w-auto">
                Explore Our Services
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero;